import { SearchResult } from '@/models/Repository'
import AccountApi from '@/api/account'

const getErrorMessage = rowErrMessage => {
  switch (rowErrMessage) {
    case 'this email is already used':
      return '入力されたメールアドレスはすでに登録されています。'
    default:
      return '保存に失敗しました。'
  }
}

export class InviteAccountRepository {
  static async getList() {
    const res = await AccountApi.getList()
    return res.items
  }

  /**
   * 広告主で絞り込む
   * @param {number} advertiserId
   * return {Account[]}
   */
  static async getListByAdvertiser(advertiserId) {
    const res = await AccountApi.search({ advertiserId })
    return res.items.map(item => new InviteAccount(item))
  }
}

export class InviteAccount {
  constructor({
    id,
    name,
    email,
    belongType,
    belongName,
    limitTime,
    registeredTime,
    userType,
  }) {
    this.id = Number(id) || undefined
    this.name = name || undefined
    this.email = email || undefined
    this.belongType = belongType || undefined
    this.belongName = belongName || undefined
    this.limitTime = limitTime || undefined
    this.registeredTime = registeredTime || undefined
    this.userType = userType || undefined
  }
  get belongTypeName() {
    switch (this.belongType) {
      case 'system owner':
        return 'システムオーナー'
      case 'agency':
        return '代理店'
      case 'advertiser':
        return '広告主'
      default:
        return ''
    }
  }

  get isSystemOwner() {
    return this.belongType === 'system owner'
  }
  get isAgency() {
    return this.belongType === 'agency'
  }
  get isAdvertiser() {
    return this.belongType === 'advertiser'
  }
  // API

  static async search({
    keyword,
    isExpiredOnly,
    belongType,
    pageSize,
    pageNo,
    sortKey,
    sortDirection,
  } = {}) {
    const query = { keyword, isExpiredOnly, belongType }
    const searchResult = await AccountApi.searchInvitations(
      query,
      pageSize,
      pageNo,
      sortKey,
      sortDirection,
    )
    const list = assignModel(searchResult)
    return new SearchResult({
      count: searchResult.count || 0,
      pageNo: searchResult.pageNo || 1,
      items: list,
      pageSize: pageSize || 20,
    })
  }

  static async delete(id) {
    return AccountApi.deleteInvite(id)
  }
}

const assignModel = data => {
  return data.items.map(o => new InviteAccount(o))
}

export class ReInviteAccountForm {
  constructor(item = {}) {
    const {
      id,
      belongType,
      belongName,
      systemOwnerId,
      agencyId,
      advertiserId,
      userType,
      name,
      email,
    } = item
    this.id = id || undefined
    this.belongType = belongType || undefined
    this.belongName = belongName || undefined
    this.systemOwnerId = systemOwnerId || undefined
    this.agencyId = agencyId || undefined
    this.advertiserId = advertiserId || undefined
    this.userType =
      belongType === 'system owner' ? 'system operator' : userType || undefined
    this.name = name || undefined
    this.email = email || undefined
    // UI制御用
    this.permission = undefined
  }
  get validation() {
    if (
      (!this.systemOwnerId && !this.agencyId && !this.advertiserId) ||
      (this.belongType !== 'system owner' && !this.userType)
    ) {
      return false
    }
    return Boolean(this.emailConfirmStatus)
  }
  get belongSelectedId() {
    switch (this.belongType) {
      case 'system owner':
        return this.systemOwnerId
      case 'agency':
        return this.agencyId
      case 'advertiser':
        return this.advertiserId
      default:
        return ''
    }
  }
  get emailConfirmStatus() {
    return this.email.indexOf('@') !== -1
  }
  async execReInvite() {
    let params = {
      email: this.email,
      name: this.name,
      userType:
        this.belongType === 'system owner' ? 'system operator' : this.userType,
    }
    const systemOwnerId =
      this.belongType === 'system owner' ? this.systemOwnerId : undefined
    const agencyId = this.belongType === 'agency' ? this.agencyId : undefined
    const advertiserId =
      this.belongType === 'advertiser' ? this.advertiserId : undefined
    try {
      const res = await AccountApi.invite(
        params,
        systemOwnerId,
        agencyId,
        advertiserId,
      )

      // 招待に成功した場合、既存の招待情報を削除
      await AccountApi.deleteInvite(this.id)

      return res
    } catch (e) {
      throw new Error(getErrorMessage(e.response.data.message))
    }
  }
}
